import { ReactComponent as FoodIcon } from "../../../assets/images/icons/food.svg";

export const CardMobile = ({ children, rest: { description = '', price = 0, unit = 1, name = 'Unknown', weight = null }, img }) => {

    return (
        <div className={`product-card position-relative mb-1 py-2 border-bottom`}>
            <div className="d-flex">
                <div className="product-image">
                    {img ? (
                        <img src={img} alt={name} />
                    ) : (
                        <FoodIcon className="default-img" />
                    )}
                </div>
                <div className="w-100">
                    <div className="row ms-0">
                        <div className="product-head d-flex justify-content-between ps-0">
                            <div className="product-title pe-2">
                                <span>{name}</span>
                            </div>
                            <div className="product-price text-end">
                                <div className="d-flex flex-column justify-content-between align-items-end">
                                    <span>{price}</span>
                                    <span className="for-unit">{children[1]}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row ms-0 justify-content-between">
                        <div className="col col-md-10 ps-0 pe-0">
                            <div className="product-description">
                                <span>{description} </span>
                                
                            </div>
                            {weight && <p className="mb-0" style={{fontSize: '12px'}}><span className="fw-bold">Вага:</span> {weight}г</p> }
                        </div>
                        <div className="col-5 w-auto ms-1 col-md-2 ps-0">
                            <div className="d-flex flex-column justify-content-between align-items-end">
                                {children[0]}
                                {children[2]}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
